import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { MessageService } from '../../../services/login.service';
import { KapraoService } from 'src/services/kaprao.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
})
export class TopnavComponent implements OnInit {
  @Input() userProfile;
  isLogin = false;
  showFiller = false;
  isOpen: boolean;
  selectedLang;
  isPrint = false;
  constructor(
    private messageService: MessageService,
    private router: Router,
    private service: KapraoService,
    public translate: TranslateService
  ) {
    this.selectedLang = translate.currentLang;
  }

  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      this.isLogin = true;
    }
  }
  selectedValue(value) {
    this.selectedLang = value;
  }
  logout() {
    localStorage.clear();
    this.messageService.sendMessage('logout');
    this.router.navigate(['login']);
    // this.service.logout().then((res: any) => {
    //   localStorage.clear();
    //   this.messageService.sendMessage('logout');
    //   this.router.navigate(['login']);
    // });
  }
}
